import React from 'react';
import { css } from '@emotion/react';
import { useDispatch } from 'react-redux';
import t from 'react-translate';
import { openNovoAIDialog } from 'redux/actions/help-options';
import { HelpOptions } from 'redux/schemas/models/help-options';
import AskNovoAIButton from 'institutions/components/ask-novoai/components/ask-novo-ai-button';
import { halfSpacing, doubleSpacing, standardSpacing } from 'styles/global_defaults/scaffolding';
import { darkGray } from 'athena/styles/colors';

const styles = css`
  min-width: 250px;

  .button-wrapper {
    margin-top: 0;
    justify-content: flex-start;
  }

  .novoai-button {
    align-items: center;
    display: flex;
    gap: 8px;
  }

  .help-menu-header {
    margin-top: 0;
    font-weight: 600;
    margin-bottom: ${halfSpacing}px;
  }

  .help-menu-body {
    margin-bottom: ${doubleSpacing}px;

    .btn {
      max-width: 100%;
      white-space: normal;
      overflow-wrap: anywhere;
    }
  }

  .bottom-line {
    border-bottom: 1px solid #e0e0e0;
    margin: ${standardSpacing}px 0;
  }

  .help-menu-header {
    color: ${darkGray};
  }
`;

interface HelpWidgetPopoverProps {
  showAiAssistant: boolean;
  shouldDisableAskNovoAI: boolean;
  helpOptions: HelpOptions | undefined;
  onClose: () => void;
}

export const HelpWidgetPopover: React.FC<HelpWidgetPopoverProps> = ({
  showAiAssistant,
  shouldDisableAskNovoAI,
  helpOptions,
  onClose,
}) => {
  const dispatch = useDispatch();

  const handleAiButtonClick = () => {
    onClose();
    dispatch(openNovoAIDialog());
  };

  const courseHelp = helpOptions?.courseHelp;
  const hasHelpResources = helpOptions?.hasHelpResourcesEnabled && courseHelp;

  return (
    <div css={styles}>
      {/* AI Assistant Section */}
      {showAiAssistant && (
        <div>
          <h3 className='label course-title-xss help-menu-header'>
            {t.INSTITUTIONS.ADVANCED_SETTINGS.HELP_OPTIONS.LEARNING_ASSISTANT()}
          </h3>
          <AskNovoAIButton
            onClick={handleAiButtonClick}
            disabled={shouldDisableAskNovoAI}
          >
            {t.INSTITUTIONS.ADVANCED_SETTINGS.HELP_OPTIONS.LEARNING_ASSISTANT_BUTTON()}
          </AskNovoAIButton>
        </div>
      )}

      {/* Divider if both sections are present */}
      {showAiAssistant && hasHelpResources && (
        <div className='bottom-line' />
      )}

      {/* Help Resources Section */}
      {hasHelpResources && (
        <div>
          <h3 className='label course-title-xss help-menu-header'>
            {courseHelp.title}
          </h3>
          <div
            className='blue-links help-menu-body'
            dangerouslySetInnerHTML={{ __html: courseHelp.body }}
          />
        </div>
      )}
    </div>
  );
};

export default HelpWidgetPopover;
